import { ApiClient } from '../../../../Shared/interfaces/ApiClient';
import { ENDPOINTS } from '../../../constants/endpoints';
import { BOOKING_STATUS } from '../../CreateBooking/constants/DetailedBookingConstants';
import { DownloadBookingFilters } from '../utils/downloadFilters';

const { BOOKINGS_ENDPOINT, DOWNLOAD_BOOKING, BATCH_UPDATE_BOOKINGS } = ENDPOINTS;

export const deleteBooking = (api: ApiClient, bookingId: string) => {
  return api.delete(`${BOOKINGS_ENDPOINT}/${bookingId}`);
};

export const restoreBooking = (api: ApiClient, bookingId: string) => {
  return api.put(`${BOOKINGS_ENDPOINT}/${bookingId}`, {
    booking: { bookingStatus: BOOKING_STATUS.ACTIVE },
  });
};

export const cancelBooking = (api: ApiClient, bookingId: string) => {
  return api.put(`${BOOKINGS_ENDPOINT}/${bookingId}`, {
    booking: { bookingStatus: BOOKING_STATUS.CANCELLED },
  });
};

export const bulkUpdateGtmStatus = (
  api: ApiClient,
  artEventId: string,
  bookingIds: string[],
  gtmStatus: string
) => {
  return api.put(BATCH_UPDATE_BOOKINGS, { artEventId, bookingIds, updates: { gtmStatus } });
};

export const downloadBookingSheet = (
  api: ApiClient,
  artEventId: string,
  bookingStatus: string,
  filters: DownloadBookingFilters = {}
) => {
  const params = new URLSearchParams({ artEventId });
  if (bookingStatus) params.set('bookingStatus', bookingStatus);

  // Repeated query params (brandNames=a&brandNames=b) map to the backend's
  // List<String> @QueryParam bindings so the export honors the grid filters.
  // Empty lists append nothing, so an unfiltered export sends no filter params.
  // Optional chaining stays defensive against a partial object at the JS boundary.
  filters.brandNames?.forEach((brand) => params.append('brandNames', brand));
  filters.slotNames?.forEach((slot) => params.append('slotNames', slot));
  filters.gtmStatuses?.forEach((gtm) => params.append('gtmStatuses', gtm));

  return api.get(`${DOWNLOAD_BOOKING}?${params}`, 'blob');
};
